import * as tslib_1 from "tslib";
import { getTranslations, isWorker } from '@wix/wixstores-client-core/dist/src/viewer-script/utils';
import { MULTILINGUAL_TO_TRANSLATIONS_MAP, PRODUCT_WIDGET_APP_NAME, translationPath } from '../constants';
import { ProductApi } from '../services/productApi';
import { MultilingualService } from '@wix/wixstores-client-core/dist/src/multilingualService/multilingualService';
import { overrideTranslationsWithPublicData } from './productWidgetStore.utils';
import { ProductService } from '../services/ProductService';
import { PubSubManager } from '@wix/wixstores-client-core/dist/es/src/pub-sub-manager/pubSubManager';
import { getProductWidgetSettings, WidgetActionEnum, WidgetPresetIdEnum } from '../commons/styleParamsService';
import { PageMap, APP_DEFINITION_ID, StoresWidgetID } from '@wix/wixstores-client-core/dist/es/src/constants';
var ProductWidgetStore = /** @class */ (function () {
    function ProductWidgetStore(styleParams, publicData, setProps, siteStore, externalId, compId, reportError) {
        var _this = this;
        this.styleParams = styleParams;
        this.publicData = publicData;
        this.setProps = setProps;
        this.siteStore = siteStore;
        this.externalId = externalId;
        this.compId = compId;
        this.reportError = reportError;
        this.isStartReported = false;
        this.onAppLoaded = function () {
            if (!isWorker() || (_this.siteStore.isInteractive() && _this.isStartReported)) {
                _this.fedopsLogger.appLoaded();
                if (_this.siteStore.isSiteMode()) {
                    _this.reportBIOnAppLoaded();
                }
            }
            _this.isStartReported = false;
        };
        this.handleAddToCart = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var navigate;
            return tslib_1.__generator(this, function (_a) {
                navigate = this.styleParams.fonts.widgetAction.value === WidgetActionEnum.NAVIGATE || this.product.price === 0;
                return [2 /*return*/, this.productService.addToCart(this.product, navigate)];
            });
        }); };
        this.navigate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.siteStore.navigate({
                        sectionId: PageMap.PRODUCT,
                        state: this.product.urlPart,
                        queryParams: undefined,
                    }, true)];
            });
        }); };
        this.productApi = new ProductApi(this.siteStore);
        this.pubSubManager = new PubSubManager(this.siteStore.pubSub);
        if (isWorker()) {
            var fedopsLoggerFactory = this.siteStore.platformServices.fedOpsLoggerFactory;
            this.fedopsLogger = fedopsLoggerFactory.getLoggerForWidget({
                appId: APP_DEFINITION_ID,
                widgetId: StoresWidgetID.PRODUCT_WIDGET,
            });
            this.fedopsLogger.appLoadStarted();
            this.isStartReported = true;
        }
        else {
            this.fedopsLogger = this.siteStore.fedopsFactory.create(PRODUCT_WIDGET_APP_NAME);
        }
        this.productService = new ProductService(siteStore, this.pubSubManager, compId, externalId, this.fedopsLogger);
    }
    ProductWidgetStore.prototype.reportBIOnAppLoaded = function () {
        var _this = this;
        var settings = getProductWidgetSettings(this.styleParams);
        var showButtonSetting = function () {
            if (!_this.siteStore.isMobile() && settings.hoverButtonToggle) {
                return 'hover';
            }
            return settings.widgetButtonToggle ? 'always' : 'never';
        };
        var eventData = {
            isMobileFriendly: this.siteStore.isMobileFriendly,
            testName: 'product_widget_loaded',
            is_eligible: true,
            type: JSON.stringify({
                orientation: this.widgetPreset === WidgetPresetIdEnum.HORIZONTAL ? 'horizontal' : 'vertical',
                show_button: showButtonSetting(),
                button: settings.widgetAction,
                alignment: settings.alignment,
                image_resize: settings.imageScaling,
                show_title: settings.titleToggle,
                show_price: settings.priceToggle,
                show_divider: settings.separatorToggle,
            }),
        };
        //tslint:disable-next-line:no-floating-promises
        this.siteStore.biLogger.exposureEventForTests(eventData);
    };
    ProductWidgetStore.prototype.getTexts = function () {
        var _this = this;
        return Object.keys(MULTILINGUAL_TO_TRANSLATIONS_MAP).reduce(function (acc, translationKey) {
            var multiligualKey = MULTILINGUAL_TO_TRANSLATIONS_MAP[translationKey];
            var override = _this.multilingualService.get(multiligualKey);
            if (override) {
                acc[translationKey] = override;
            }
            return acc;
        }, tslib_1.__assign({}, this.translations));
    };
    ProductWidgetStore.prototype.getProductWidgetTranslations = function () {
        return getTranslations(translationPath(this.siteStore.baseUrls.productWidgetBaseUrl, this.siteStore.locale));
    };
    ProductWidgetStore.prototype.setInitialState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, translations, data, url, propsToInject;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.getProductWidgetTranslations(),
                            this.productApi.getData(this.externalId, this.compId),
                            this.siteStore.getSectionUrl(PageMap.PRODUCT),
                        ]).catch(this.reportError)];
                    case 1:
                        _a = _b.sent(), translations = _a[0], data = _a[1].data, url = _a[2].url;
                        this.product = data.catalog.product;
                        this.translations = overrideTranslationsWithPublicData(translations, this.publicData);
                        this.multilingualService = new MultilingualService(this.publicData.COMPONENT || {}, data.appSettings.widgetSettings, this.siteStore.getMultiLangFields(), this.siteStore.locale);
                        propsToInject = {
                            cssBaseUrl: this.siteStore.baseUrls.productWidgetBaseUrl,
                            onAppLoaded: this.onAppLoaded,
                            isInteractive: this.siteStore.isInteractive(),
                            product: this.product,
                            texts: this.getTexts(),
                            isSEO: this.siteStore.seo.isInSEO(),
                            handleAddToCart: this.handleAddToCart,
                            navigate: this.navigate,
                            productPageUrl: this.product && this.product.urlPart ? url + "/" + this.product.urlPart : '',
                            widgetPreset: this.widgetPreset,
                            horizontalLayout: this.widgetPreset === WidgetPresetIdEnum.HORIZONTAL && !this.siteStore.isMobile(),
                            isMobile: this.siteStore.isMobile(),
                            experiments: {
                                newAddToCartButton: this.siteStore.experiments.enabled('specs.stores.NewAddToCartButton'),
                            },
                        };
                        this.setProps(propsToInject);
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductWidgetStore.prototype.updatePublicData = function (newPublicData) {
        var _this = this;
        Object.keys(newPublicData.COMPONENT).forEach(function (key) {
            _this.publicData.COMPONENT[key] = newPublicData.COMPONENT[key];
        });
    };
    ProductWidgetStore.prototype.updateState = function (newStyleParams, newPublicData) {
        this.updatePublicData(newPublicData);
        this.styleParams = newStyleParams;
        this.translations = overrideTranslationsWithPublicData(this.translations, this.publicData);
        this.multilingualService.setWidgetSettings(newPublicData.appSettings);
        this.setProps({
            texts: this.getTexts(),
        });
    };
    Object.defineProperty(ProductWidgetStore.prototype, "widgetPreset", {
        get: function () {
            return (this.publicData.COMPONENT && this.publicData.COMPONENT.presetId) || WidgetPresetIdEnum.VERTICAL;
        },
        enumerable: true,
        configurable: true
    });
    return ProductWidgetStore;
}());
export { ProductWidgetStore };
//# sourceMappingURL=productWidgetStore.js.map